import React, { useState } from "react";
import { Helmet } from "react-helmet-async";

import backIcon from "..//assets/res/back_icon.svg";
import appleIcon from "..//assets/res/apple_white.svg";
import downloadIcon from "..//assets/res/download_icon.svg";
import androidIcon from "..//assets/res/android_white.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GET_BASE_URL } from "../utils/Constants";
import OffersScreen from "./OffersScreen";

const detectPlatform = () => {
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";
  return "android";
};

const InfoBlock = ({ showLeftDivier = false, title, value }) => {
  return (
    <div className="flex flex-row">
      {showLeftDivier && (
        <div className="h-12 w-[0.5px] bg-gray-800 mr-6 mt-1"></div>
      )}
      <div className="flex flex-col items-center  ">
        <div className="text-white medium tracking-wide  text-center text-xs">
          {title}
        </div>
        <div className="text-gray-300 medium text-base  text-center tracking-wide">
          {value}
        </div>
      </div>
      <div className="h-12 w-[0.5px] bg-gray-800 ml-6 mt-1"></div>
    </div>
  );
};

const InfoBlockPlatform = ({ title, isForAndroid, isForIos }) => {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col items-center  ">
        <div className="text-white medium tracking-wide  text-center text-xs">
          {" "}
          {title}
        </div>
        <div className="flex flex-row justify-center mt-1">
          {isForAndroid && <img src={androidIcon} className="h-5 w-5" />}
          {isForIos && <img src={appleIcon} className="h-5 w-5 ml-2" />}
        </div>
      </div>
      <div className="h-12 w-[0.5px] bg-gray-800 ml-6 mt-1"></div>
    </div>
  );
};

const DetailsPage = ({ fromPage, selectedGame, handleClose, numbers }) => {
  const [showOffers, setShowOffers] = useState(false);
  const [platform, setPlatform] = useState("");

  if (!selectedGame) return;

  const {
    name,
    description,
    image_path,
    rate,
    size,
    author,
    download,
    isForAndroid,
    isForIos,
    gameKeywords,
  } = selectedGame;

  function handleDownload() {
    setPlatform(detectPlatform());
    setShowOffers(true);
  }

  return (
    <>
      <Helmet>
        <title> {name}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={gameKeywords} />
      </Helmet>

      <div className="bg-black  flex flex-col p-4 h-full bg-gradient-to-r from-semi-blue to-light-blue">
        <div className="flex flex-row items-center " onClick={handleClose}>
          <img
            className="h-8 w-8 object-cover object-center -ml-2"
            src={backIcon}
            alt="Back"
          />
          <div className="text-white semiBold text-2xl pt-0.5">{fromPage}</div>
        </div>
        {/* HEAD START */}

        <div className="flex flex-col mx-auto mt-[16px] items-center">
          <div className="h-32 w-32 rounded-2xl bg-gray-900 flex-none border-[0.5px]">
            <img
              className="h-32 w-32 object-cover object-center rounded-2xl"
              src={GET_BASE_URL() + "images/" + image_path}
              alt={name}
            />
          </div>
          <div className="text-white semiBold text-2xl line-clamp-2 mt-3 text-center">
            {name}
          </div>
          <div class="relative rounded-full  mt-[32px] animate-bounce">
            <div class="absolute -inset-[2px] rounded-full w-[200px] bg-gradient-to-r from-yellow-600 via-orange-600 to-red-600 opacity-90 "></div>
            <div class="relative flex flex-row items-center justify-center rounded-full bg-slate-900 text-slate-300">
              <div
                className="rounded-full flex flex-row justify-center text-white medium text-base bg-dark-blue w-[195px] pt-[6px] pb-[4px] flex flex-row"
                onClick={handleDownload}
              >
                <h1 className=" text-[18px]">Download</h1>
                <div className="h-[24px] w-[24px]  ml-2 ">
                  <img src={downloadIcon} className="h-[22px]   w-[22px] " />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row items-center gap-1 mt-3">
            <span className="text-green-400 text-xs medium">✓ Free</span>
            <span className="text-gray-400 text-xs">·</span>
            <span className="text-gray-400 text-xs medium">Complete a quick offer to unlock</span>
          </div>
        </div>



        {/* HEAD END */}

        <div className="h-[0.5px] bg-gray-800 mt-6" />

        <div className="flex flex-row mt-4  bg-red overflow-scroll no-scrollbar ">
          <InfoBlock showLeftDivier={true} title="RATING" value={rate} />

          <div className="w-[0.5px] bg-gray-800 my-2 mx-4"></div>
          <InfoBlock title="DEVELOPER" value={author} />
          <div className="w-[0.5px]  bg-gray-800 my-2  mx-4"></div>
          <InfoBlockPlatform
            title="PLATFORM"
            isForAndroid={isForAndroid}
            isForIos={isForIos}
          />
          <div className="w-[0.5px]  bg-gray-800 my-2  mx-4"></div>
          <InfoBlock title="DOWNLOAD" value={download + "K"} />
          <div className="w-[0.5px]  bg-gray-800 my-2  mx-4"></div>
          <InfoBlock title="SIZE" value={size} />
          <div className="w-[0.5px]  bg-gray-800 my-2  mx-4"></div>
        </div>

        <div className="h-[0.5px] bg-gray-800 mt-4" />

        <div className="medium text-m text-white tracking-wide mt-4">
          {description}
        </div>

        {/* <Rating rate={rate} /> */}
        {/*  <Privacy /> */}

        <div className="semiBold text-wider text-2xl text-white mt-4">
          Sponsored
        </div>

        {numbers.map((item) => (
          <div className="flex flex-col mt-4">
            <div className=" flex flex-row bg-dark-blue rounded-xl pr-4">
              <div className="h-20 w-20 rounded-xl  flex-none ">
                <LazyLoadImage
                  className="h-20 w-20 object-cover object-center rounded-lg"
                  src={GET_BASE_URL() + "images/" + item.image_path}
                  alt={name}
                />
              </div>
              <div className="flex flex-col justify-center ml-2 flex-none">
                <div className="text-white medium text-xl truncate w-60">
                  {item.name}
                </div>
                <div className="flex flex-row  mt-1 mb-1 ">
                  {item.isForAndroid && (
                    <img src={androidIcon} className="h-4 w-4 mr-2" />
                  )}
                  {item.isForIos && <img src={appleIcon} className="h-4 w-4 " />}
                </div>

                <div className="rounded-md bg-blue-400 w-[30px] pl-[5px] text-white text-xs">
                  Ad
                </div>
              </div>
            </div>
          </div>
        ))}

        {showOffers && (
          <OffersScreen
            platform={platform}
            imageUrl={image_path}
            nicheName={name}
            size={size}
            onClose={handleClose}
          />
        )}
      </div>
    </>
  );
};

export default DetailsPage;
